import { MdPrint, MdFileDownload } from 'react-icons/md';
import './PrintActionsHeader.css';

/**
 * Shared print/export toolbar with optional custom Start / End date filters.
 * Used on sales pages and list pages in admin + receptionist panels.
 */
export default function PrintActionsHeader({
  startDate = '',
  endDate = '',
  onStartDateChange,
  onEndDateChange,
  onClearDates,
  onPrint,
  onCsv,
  onPdf,
  onExcel,
  onExport,
  children = null,
  ariaLabel = 'Print and export actions',
  className = '',
  showDateFilter = true,
  datesReadOnly = false,
}) {
  const hasRange = Boolean(String(startDate || '').trim() || String(endDate || '').trim());

  return (
    <div className={`print-actions-header ${className}`.trim()} role="toolbar" aria-label={ariaLabel}>
      {children}
      {showDateFilter && (
        <div className="print-actions-dates">
          <div className="owner-form-group print-actions-date-field">
            <label className="owner-form-label" htmlFor="print-header-start">Start date</label>
            <input
              id="print-header-start"
              type="date"
              className="owner-form-input"
              value={startDate || ''}
              max={endDate || undefined}
              disabled={datesReadOnly}
              readOnly={datesReadOnly}
              onChange={datesReadOnly ? undefined : (e) => onStartDateChange?.(e.target.value)}
            />
          </div>
          <div className="owner-form-group print-actions-date-field">
            <label className="owner-form-label" htmlFor="print-header-end">End date</label>
            <input
              id="print-header-end"
              type="date"
              className="owner-form-input"
              value={endDate || ''}
              min={startDate || undefined}
              disabled={datesReadOnly}
              readOnly={datesReadOnly}
              onChange={datesReadOnly ? undefined : (e) => onEndDateChange?.(e.target.value)}
            />
          </div>
          {hasRange && onClearDates && !datesReadOnly ? (
            <button
              type="button"
              className="owner-btn owner-btn-secondary owner-btn-sm"
              onClick={onClearDates}
            >
              Clear dates
            </button>
          ) : null}
        </div>
      )}
      <div className="print-actions-buttons">
        {onPrint ? (
          <button type="button" className="owner-btn owner-btn-secondary owner-btn-sm" onClick={onPrint}>
            <MdPrint aria-hidden /> Print
          </button>
        ) : null}
        {onCsv ? (
          <button type="button" className="owner-btn owner-btn-secondary owner-btn-sm" onClick={onCsv}>
            <MdFileDownload aria-hidden /> CSV
          </button>
        ) : null}
        {onPdf ? (
          <button type="button" className="owner-btn owner-btn-secondary owner-btn-sm" onClick={onPdf}>
            <MdFileDownload aria-hidden /> PDF
          </button>
        ) : null}
        {onExcel ? (
          <button type="button" className="owner-btn owner-btn-secondary owner-btn-sm" onClick={onExcel}>
            <MdFileDownload aria-hidden /> Excel
          </button>
        ) : null}
        {onExport ? (
          <button type="button" className="owner-btn owner-btn-primary owner-btn-sm" onClick={onExport}>
            Export
          </button>
        ) : null}
      </div>
    </div>
  );
}
